module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-dialog', {
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  }, [(_vm.row.erweiimg.length > 0) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }), _vm._v(" "), _c('p', [_vm._v("请扫码联系工作人员")])]) : _c('div', [_c('p', [_vm._v("请联系工作人员")])])]), _vm._v(" "), _c('van-divider', {
    on: {
      "click": function($event) {
        return _vm.edit(1)
      }
    }
  }, [_vm._v("场次信息 "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "场次",
      "value": _vm.row.station_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "时间",
      "value": _vm.row.station.startdate + '至' + _vm.row.station.enddate
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "地点",
      "value": _vm.row.station.province + '  ' + _vm.row.station.city + ' ' + _vm.row.station.county
    }
  })], 1), _vm._v(" "), _c('van-divider', {
    on: {
      "click": function($event) {
        return _vm.edit(2)
      }
    }
  }, [_vm._v("人员信息 "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.row.member_list), function(membervalue, memberindex) {
    return _c('van-cell-group', {
      key: memberindex
    }, [_c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "省市区",
        "value": _vm.row.province + '  ' + _vm.row.city + ' ' + _vm.row.county + ' ' + _vm.row.address
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "姓名",
        "value": membervalue.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "身份证号",
        "value": membervalue.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "手机号",
        "value": membervalue.phone
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "微信",
        "value": membervalue.weixin
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "性别",
        "value": membervalue.sex
      }
    }), _vm._v(" "), (membervalue.need_jie == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "接站时间",
        "value": membervalue.jie_date
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_jie == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "接站车次/航班号",
        "value": membervalue.jie_code
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_song == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "送站时间",
        "value": membervalue.song_date
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_song == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "送站车次/航班号",
        "value": membervalue.song_code
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.service_name) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "服务套餐",
        "value": membervalue.service_name
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((membervalue.jsondata), function(field, fileindex) {
      return _c('van-cell', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (typeof field == 'string'),
          expression: "typeof field == 'string'"
        }],
        key: fileindex,
        attrs: {
          "input-align": "right",
          "title": fileindex,
          "value": field
        }
      })
    })], 2)
  }), _vm._v(" "), _c('van-divider', {
    on: {
      "click": function($event) {
        return _vm.edit(5)
      }
    }
  }, [_vm._v("发票信息 "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "发票抬头",
      "value": _vm.row.fapiao_taitou
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "税号",
      "value": _vm.row.fapiao_shuihao
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "地址",
      "value": _vm.row.fapiao_address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "电话",
      "value": _vm.row.fapiao_tel
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "开户行及账号",
      "value": _vm.row.fapiao_account
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "发票备注",
      "value": _vm.row.fapiao_beizhu
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "接收邮箱",
      "value": _vm.row.fapiao_email
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "接收手机",
      "value": _vm.row.fapiao_phone
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.row.confirm_1 == 2) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("信息无误 我已确认")]) : _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("信息已确认")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex($event)
      }
    }
  }, [_vm._v("返回首页")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e165fb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiConfirmDetail.vue
// module id = 2523
// module chunks = 0